module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"uso":"Uso","frecuencia_mantenimiento":"Frecuencia de mantenimiento","necesidad_higiene":"Necesidades especiales de higiene","revestimiento_existente":"Revestimiento existente"}}')
  delete Component.options._Ctor
}
